import { useState } from 'react';
import { Button, ChartRenderer } from 'components/core';
import { ChartSeries } from 'helpers/chartDataProcessors';
import { CLIPPED_CHART_TYPES, chartLength, clipChart, previewLimit } from 'helpers/kpiBuilder/previewRequest';
import { OUTLINE_SMALL } from './buttonProps';

interface ClippedChartProps {
  chartType: string;
  data: ChartSeries[];
}

// The chart for the preview. A long table or ranking shows its first rows only, with a way to see the rest; other charts are drawn whole.
export const ClippedChart = ({ chartType, data }: ClippedChartProps) => {
  const [showAll, setShowAll] = useState(false);
  const limit = previewLimit(chartType);
  const total = CLIPPED_CHART_TYPES.includes(chartType) ? chartLength(chartType, data) : 0;
  const clipped = total > limit && !showAll;
  return (
    <>
      <ChartRenderer chartType={chartType} chartData={clipped ? clipChart(chartType, data) : data} prepared />
      {total > limit && (
        <div className="d-flex align-items-center gap-2 small text-secondary mt-2">
          <span>{clipped ? `Showing first ${limit} of ${total}` : `Showing all ${total}`}</span>
          <Button {...OUTLINE_SMALL} onClick={() => setShowAll(clipped)}>
            {clipped ? 'View all' : 'Show less'}
          </Button>
        </div>
      )}
    </>
  );
};
